import React, { Component } from 'react';
import { Row, Col } from 'antd';

import SearchMobile from './SearchMobile/SearchMobile';
import SearchWeb from './SearchWeb/SearchWeb';
import PropTypes from 'prop-types';

class SearchSection extends Component {
  render() {
    const options = [
      { key: 'lastNameAsc', value: 'Last Name - A to Z' },
      { key: 'firstNameAsc', value: 'First Name - A to Z' },
      { key: 'BalanceAsc', value: 'Current Balance - Low to High' },
      { key: 'BalanceDesc', value: 'Current Balance - High to Low' },
    ];
    const {
      filters,
      changeState,
      filterType,
      searched,
      restored,
      sorted,
      assets,
      value,
      selectedVal,
      clicked,
      closed,
      selected,
      mobileViewHandler,
      mobileViewFlag,
      closeFilter,
      typed,
    } = this.props;
    return (
      <Row>
        <Col xs={{ span: 0 }} md={{ span: 24 }} lg={{ span: 24 }}>
          <SearchWeb
            options={options}
            clicked={clicked}
            value={value}
            assetsDetails={assets}
            sorted={(value) => sorted(value)}
            searched={searched}
            filterType={filterType}
            filters={filters}
            changeState={changeState}
            restored={restored}
            selectedVal={selectedVal}
            closed={closed}
            selected={selected}
            reset={closeFilter}
            typed={typed}
          />
        </Col>
        <Col xs={{ span: 24 }} lg={{ span: 0 }} md={{ span: 0 }}>
          <SearchMobile
            options={options}
            clicked={clicked}
            value={value}
            assetsDetails={assets}
            sorted={(value) => sorted(value)}
            searched={searched}
            filterType={filterType}
            filters={filters}
            changeState={changeState}
            restored={restored}
            selectedVal={selectedVal}
            closed={closed}
            selected={selected}
            mobileViewHandler={mobileViewHandler}
            mobileViewFlag={mobileViewFlag}
            reset={closeFilter}
            typed={typed}
          />
        </Col>
      </Row>
    );
  }
}
SearchSection.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.object),
  changeState: PropTypes.func,
  filterType: PropTypes.string,
  searched: PropTypes.func,
  restored: PropTypes.func,
  sorted: PropTypes.func,
  assets: PropTypes.object,
  value: PropTypes.string,
  selectedVal: PropTypes.string,
  clicked: PropTypes.func,
  closed: PropTypes.func,
  selected: PropTypes.func,
  mobileViewHandler: PropTypes.func,
  mobileViewFlag: PropTypes.bool,
  closeFilter: PropTypes.func,
};
export default SearchSection;
